import React from "react";

import { Line } from "react-chartjs-2";
import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);

const VerticalLineChart = ({ chartData }) => {
  return (
    <div>
      <Line
        data={chartData}
        options={{
          // indexAxis: 'y', //uncomment this to convert the chart into vertical line chart
          // Elements options apply to all of the options unless overridden in a dataset
          // In this case, we are setting the border of each horizontal bar to be 2px wide
          elements: {
            bar: {
              borderWidth: 10,
            }
          },
          responsive: true,
          plugins: {
            title: {
              display: true,
              text: "Timestamps"
            },
            legend: {
              display: true,
              position: "right"
           }
          }
        }}
      />
    </div>
  );
};

function TimestampChart({ columns, data, rowClickHandler }) {
  let jsondatastring=JSON.stringify(data);
  let jsondata=JSON.parse(jsondatastring);
//   let tempjson=data.json();
  // console.log(jsondata);  

  let timestamps=jsondata.map(a=>a.timestamp);
  let tempaprs=jsondata.map(a=>a.apr );

  let aprs=[];
  let tempstr="";
  for( let i=0;i<tempaprs.length;i=i+1)
  { 
    tempstr=tempaprs[i].slice(0, -2);
    // console.log(tempstr);
    aprs.push(Number(tempstr)); 
  }


  console.log(timestamps);

  const chartData = {
    labels: timestamps,
    datasets: [{
      label: 'Apr',
      data: aprs,
      borderColor: 'rgba(30, 139, 195, 1)'	,
      backgroundColor: 'rgba(255, 255, 255, 1)',
      borderWidth: 3,
    }]
  };

  return (
    <div className="timestampchart">
      <VerticalLineChart chartData={chartData}/>
    </div>
  );
}


export default TimestampChart;
